module.exports = __webpack_public_path__ + "static/media/reggora.0ae14fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/experiences/reggora.png
// module id = 95
// module chunks = 0